export const PROFILE_PIC_PATH = 'profile_pic'
export const COMPANY_PIC_PATH = 'company_pic'